import { useRef } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { FIELD_MONO_STYLE, FIELD_OPTION_STYLE } from "./wizardStyles";

// Stable per-instance ids for <datalist> pairing (React 17 has no useId).
let comboFieldSeq = 0;

/** Compact labelled form field used inside wizard panels. */
export function PanelField({
  label,
  value,
  onChange,
  type = "text",
  mono = false,
  readOnly = false,
  placeholder = "—",
  min,
  max,
  step,
  autoComplete,
}) {
  return (
    <FormGroup>
      <Label className="text-muted small mb-1">{label}</Label>
      <Input
        type={type}
        min={min}
        max={max}
        step={step}
        value={value ?? ""}
        placeholder={placeholder}
        readOnly={readOnly}
        autoComplete={autoComplete}
        onChange={readOnly ? undefined : (e) => onChange?.(e.target.value)}
        style={mono ? FIELD_MONO_STYLE : undefined}
      />
    </FormGroup>
  );
}

// Text field with datalist suggestions: pick from `options` or type a custom value.
export function PanelComboField({ label, value, onChange, options, placeholder = "—", autoComplete, maxLength }) {
  const listIdRef = useRef(null);
  if (listIdRef.current === null) listIdRef.current = `panel-combo-${(comboFieldSeq += 1)}`;
  const listId = listIdRef.current;
  return (
    <FormGroup>
      <Label className="text-muted small mb-1">{label}</Label>
      <Input
        type="text"
        list={listId}
        maxLength={maxLength}
        value={value ?? ""}
        placeholder={placeholder}
        autoComplete={autoComplete}
        onChange={(e) => onChange?.(e.target.value)}
      />
      <datalist id={listId}>
        {options.map((opt) => (
          <option key={opt} value={opt} />
        ))}
      </datalist>
    </FormGroup>
  );
}

export function PanelSelectField({ label, value, onChange, options, placeholder = "— Select —", disabled = false }) {
  return (
    <FormGroup>
      <Label className="text-muted small mb-1">{label}</Label>
      <Input type="select" value={value ?? ""} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
        <option value="" style={FIELD_OPTION_STYLE}>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} style={FIELD_OPTION_STYLE}>
            {opt.label}
          </option>
        ))}
      </Input>
    </FormGroup>
  );
}
